import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../Context/LanguageContext';

const LanguageSwitcher = () => {
  const { language, changeLanguage, supportedLanguages } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languageNames = {
    en: 'English',
    ar: 'العربية',
    fa: 'فارسی',
  };

  const languageFlags = {
    en: '🇬🇧',
    ar: '🇸🇦',
    fa: '🇮🇷',
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLanguageChange = (lang) => {
    changeLanguage(lang);
    setIsOpen(false);
  };

  return (
    <div className="language-switcher position-relative" ref={dropdownRef}>
      <button
        className="btn btn-sm btn-outline-light d-flex align-items-center"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Change language"
      >
        <span className="me-2">{languageFlags[language]}</span>
        <span>{languageNames[language]}</span>
        <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'} ms-2`}></i>
      </button>

      {isOpen && (
        <div className="language-dropdown position-absolute bg-white shadow-lg rounded mt-2" style={{ minWidth: '150px', zIndex: 1000 }}>
          {supportedLanguages.map((lang) => (
            <button
              key={lang}
              className={`w-100 text-start btn btn-sm ${
                language === lang ? 'btn-primary' : 'btn-light'
              } d-flex align-items-center px-3 py-2 border-0`}
              onClick={() => handleLanguageChange(lang)}
              style={{ borderRadius: 0 }}
            >
              <span className="me-2">{languageFlags[lang]}</span>
              <span>{languageNames[lang]}</span>
              {language === lang && (
                <i className="fas fa-check ms-auto"></i>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;





